/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { MusdV3 } from "../MusdV3";

export class MusdV3__factory extends ContractFactory {
  constructor(linkLibraryAddresses: MusdV3LibraryAddresses, signer?: Signer) {
    super(_abi, MusdV3__factory.linkBytecode(linkLibraryAddresses), signer);
  }

  static linkBytecode(linkLibraryAddresses: MusdV3LibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$4ff61640dcfbdf6af5752b96f9de1a9efe\\$__", "g"),
      linkLibraryAddresses["__$4ff61640dcfbdf6af5752b96f9de1a9efe$__"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$1a38b0db2bd175b310a9a3f8697d44eb75\\$__", "g"),
      linkLibraryAddresses["__$1a38b0db2bd175b310a9a3f8697d44eb75$__"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  deploy(_nexus: string, overrides?: Overrides): Promise<MusdV3> {
    return super.deploy(_nexus, overrides || {}) as Promise<MusdV3>;
  }
  getDeployTransaction(
    _nexus: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_nexus, overrides || {});
  }
  attach(address: string): MusdV3 {
    return super.attach(address) as MusdV3;
  }
  connect(signer: Signer): MusdV3__factory {
    return super.connect(signer) as MusdV3__factory;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): MusdV3 {
    return new Contract(address, _abi, signerOrProvider) as MusdV3;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_nexus",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "cacheSize",
        type: "uint256",
      },
    ],
    name: "CacheSizeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "swapFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "redemptionFee",
        type: "uint256",
      },
    ],
    name: "FeesChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "forgeValidator",
        type: "address",
      },
    ],
    name: "ForgeValidatorChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mAssetQuantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "input",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "inputQuantity",
        type: "uint256",
      },
    ],
    name: "Minted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mAssetQuantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "inputs",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "inputQuantities",
        type: "uint256[]",
      },
    ],
    name: "MintedMulti",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "redeemer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mAssetQuantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "output",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "outputQuantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "scaledFee",
        type: "uint256",
      },
    ],
    name: "Redeemed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "redeemer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mAssetQuantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "outputs",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "outputQuantity",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "scaledFee",
        type: "uint256",
      },
    ],
    name: "RedeemedMulti",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "swapper",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "input",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "output",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "outputAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "scaledFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "Swapped",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "min",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "max",
        type: "uint128",
      },
    ],
    name: "WeightLimitsChanged",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ampData",
    outputs: [
      {
        internalType: "uint64",
        name: "initialA",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "targetA",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "rampStartTime",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "rampEndTime",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "bAssetData",
    outputs: [
      {
        internalType: "uint128",
        name: "ratio",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "vaultBalance",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "bAssetIndexes",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "bAssetPersonal",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "address",
        name: "integrator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "hasTxFee",
        type: "bool",
      },
      {
        internalType: "enum BassetStatus",
        name: "status",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "basket",
    outputs: [
      {
        internalType: "bool",
        name: "undergoingRecol",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "failed",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cacheSize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "collectInterest",
    outputs: [
      {
        internalType: "uint256",
        name: "mintAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "newSupply",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "collectPlatformInterest",
    outputs: [
      {
        internalType: "uint256",
        name: "mintAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "newSupply",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "forgeValidator",
    outputs: [
      {
        internalType: "contract IInvariantValidator",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBasket",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bAsset",
        type: "address",
      },
    ],
    name: "getBasset",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "address",
            name: "integrator",
            type: "address",
          },
          {
            internalType: "bool",
            name: "hasTxFee",
            type: "bool",
          },
          {
            internalType: "enum BassetStatus",
            name: "status",
            type: "uint8",
          },
        ],
        internalType: "struct BassetPersonal",
        name: "personal",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData",
        name: "data",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBassets",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "address",
            name: "integrator",
            type: "address",
          },
          {
            internalType: "bool",
            name: "hasTxFee",
            type: "bool",
          },
          {
            internalType: "enum BassetStatus",
            name: "status",
            type: "uint8",
          },
        ],
        internalType: "struct BassetPersonal[]",
        name: "personal",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData[]",
        name: "data",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getConfig",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "config",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_inputs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_inputQuantities",
        type: "uint256[]",
      },
    ],
    name: "getMintMultiOutput",
    outputs: [
      {
        internalType: "uint256",
        name: "mintOutput",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_input",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_inputQuantity",
        type: "uint256",
      },
    ],
    name: "getMintOutput",
    outputs: [
      {
        internalType: "uint256",
        name: "mintOutput",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_outputs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_outputQuantities",
        type: "uint256[]",
      },
    ],
    name: "getRedeemExactBassetsOutput",
    outputs: [
      {
        internalType: "uint256",
        name: "mAssetQuantity",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_output",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_mAssetQuantity",
        type: "uint256",
      },
    ],
    name: "getRedeemOutput",
    outputs: [
      {
        internalType: "uint256",
        name: "bAssetOutput",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_input",
        type: "address",
      },
      {
        internalType: "address",
        name: "_output",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_inputQuantity",
        type: "uint256",
      },
    ],
    name: "getSwapOutput",
    outputs: [
      {
        internalType: "uint256",
        name: "swapOutput",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bAsset",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_belowPeg",
        type: "bool",
      },
    ],
    name: "handlePegLoss",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "maxBassets",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_bAssets",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "_newIntegration",
        type: "address",
      },
    ],
    name: "migrateBassets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_input",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_inputQuantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minOutputQuantity",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "mintOutput",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_inputs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_inputQuantities",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_minOutputQuantity",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
    ],
    name: "mintMulti",
    outputs: [
      {
        internalType: "uint256",
        name: "mintOutput",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bAsset",
        type: "address",
      },
    ],
    name: "negateIsolation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nexus",
    outputs: [
      {
        internalType: "contract INexus",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_output",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_mAssetQuantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minOutputQuantity",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
    ],
    name: "redeem",
    outputs: [
      {
        internalType: "uint256",
        name: "outputQuantity",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_outputs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_outputQuantities",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_maxMassetQuantity",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
    ],
    name: "redeemExactBassets",
    outputs: [
      {
        internalType: "uint256",
        name: "mAssetQuantity",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_mAssetQuantity",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "_minOutputQuantities",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
    ],
    name: "redeemMasset",
    outputs: [
      {
        internalType: "uint256[]",
        name: "outputQuantities",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "redemptionFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_cacheSize",
        type: "uint256",
      },
    ],
    name: "setCacheSize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_swapFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_redemptionFee",
        type: "uint256",
      },
    ],
    name: "setFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bAsset",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_flag",
        type: "bool",
      },
    ],
    name: "setTransferFeesFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "_min",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "_max",
        type: "uint128",
      },
    ],
    name: "setWeightLimits",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_targetA",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_rampEndTime",
        type: "uint256",
      },
    ],
    name: "startRampA",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stopRampA",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "surplus",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_input",
        type: "address",
      },
      {
        internalType: "address",
        name: "_output",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_inputQuantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minOutputQuantity",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
    ],
    name: "swap",
    outputs: [
      {
        internalType: "uint256",
        name: "swapOutput",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "swapFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_forgeValidator",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "_config",
        type: "tuple",
      },
    ],
    name: "upgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newForgeValidator",
        type: "address",
      },
    ],
    name: "upgradeForgeValidator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "weightLimits",
    outputs: [
      {
        internalType: "uint128",
        name: "min",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "max",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x60a06040523480156200001157600080fd5b5060405162005bc738038062005bc78339810160408190526200003491620000a7565b806001600160a01b038116620000905760405162461bcd60e51b815260206004820152601560248201527f4e657875732061646472657373206973207a65726f0000000000000000000000604482015260640160405180910390fd5b60601b6001600160601b03191660805250620000d7565b600060208284031215620000b9578081fd5b81516001600160a01b0381168114620000d0578182fd5b9392505050565b60805160601c615ac36200010460003960008181610660015281816148b8015261497f0152615ac36000f3fe608060405234801561001057600080fd5b506004361061030c5760003560e01c80636d5d6eb11161019d578063aa5d27e9116100e9578063cd6ef2b0116100a2578063dd62ed3e1161007c578063dd62ed3e14610783578063e5555b8f146107bc578063edc832b3146107cf578063f74bfe8e146107e55761030c565b8063cd6ef2b014610736578063d5bcb9b51461075d578063d7d52266146107705761030c565b8063aa5d27e9146106c0578063ab06346c146106d3578063af290bd4146106f3578063bdfbe29c14610706578063c3f909d414610719578063c4db7fa01461072e5761030c565b8063905e891411610156578063a1c2515111610130578063a1c2515114610648578063a3f5c1d21461065b578063a457c2d71461069a578063a9059cbb146106ad5761030c565b8063905e89141461061a57806395d89b411461062d578063969642b9146106355761030c565b80636d5d6eb1146105b35780636fb3e89c146105c657806370a08231146105d957806372ea9076146105ec57806378aa987e146105ff5780637e8901ea146106125761030c565b806326bbe60a1161025c57806343bcfab61161021557806354cf2aeb116101ef57806354cf2aeb1461052f578063598362f014610538578063674a64e01461059d5780636c36581c146105a65761030c565b806343bcfab61461050057806344e3fa3c14610513578063458f5815146105265761030c565b806326bbe60a1461045c5780632a2fab221461046f5780632f91a7241461048c578063313ce567146104c157806339509351146104cc5780633e37bcbc146104df5761030c565b806313888565116102c95780631820783d116102a35780631820783d146103e25780631d3ce398146103f5578063213c501a1461040b57806323b872dd146104495761030c565b806313888565146103be57806317036826146103c757806318160ddd146103da5761030c565b80630357359c1461031157806304de5a731461033d57806306fdde031461035e578063095ea7b3146103735780630b78f9c014610396578063119849cf146103ab575b600080fd5b61032461031f366004615089565b6107f8565b60405161033494939291906153fe565b60405180910390f35b61035061034b366004614f67565b610848565b604051908152602001610334565b6103666109ac565b604051610334919061573c565b610386610381366004614e9f565b610a3f565b6040519015158152602001610334565b6103a96103a43660046151bc565b610a56565b005b6103506103b9366004614e9f565b610b30565b61035060485481565b6103a96103d5366004614e0f565b610bf4565b603554610350565b6103a96103f0366004615089565b610dbe565b6103fd610e4b565b6040516103349291906155ed565b604f54610429906001600160801b0380821691600160801b90041682565b604080516001600160801b03938416815292909116602083015201610334565b610386610457366004614d40565b610fa8565b6103a961046a366004614cd0565b61105b565b610477611142565b60408051928352602083019190915201610334565b6104af61049a366004614cd0565b604b6020526000908152604090205460ff1681565b60405160ff9091168152602001610334565b60385460ff166104af565b6103866104da366004614e9f565b6111f3565b6104f26104ed366004614cd0565b61122a565b604051610334929190615811565b61035061050e366004614eca565b6113e1565b6103a96105213660046151bc565b61144a565b61035060465481565b61035060445481565b604e5461056a906001600160401b0380821691600160401b8104821691600160801b8204811691600160c01b90041684565b604080516001600160401b0395861681529385166020850152918416918301919091529091166060820152608001610334565b61035060475481565b604c546104af9060ff1681565b6104296105c1366004615089565b6114e7565b6103a96105d4366004614f13565b61151c565b6103506105e7366004614cd0565b61159a565b6103506105fa366004614d40565b6115b9565b61035061060d366004614e9f565b611786565b61047761186d565b6103a9610628366004614dde565b611a3d565b610366611aa2565b6103a9610643366004614cd0565b611ab1565b6103a9610656366004615057565b611b3c565b6106827f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b039091168152602001610334565b6103866106a8366004614e9f565b611c88565b6103866106bb366004614e9f565b611d23565b6103506106ce366004614fcf565b611d30565b6106e66106e13660046150b9565b611e00565b6040516103349190615729565b610350610701366004614fcf565b611e4d565b6103a9610714366004614dde565b611eff565b610721611f5d565b6040516103349190615873565b6103a9611f72565b604d5460ff808216916101009004165b604080519215158352901515602083015201610334565b61035061076b366004614d80565b611ff4565b604254610682906001600160a01b031681565b610350610791366004614d08565b6001600160a01b03918216600090815260346020908152604080832093909416825291909152205490565b6103506107ca366004614f67565b61205f565b604d546107469060ff8082169161010090041682565b6103506107f3366004614eca565b61218e565b6049818154811061080857600080fd5b6000918252602090912060029091020180546001909101546001600160a01b0391821692509081169060ff600160a01b8204811691600160a81b90041684565b600081801580159061085957508085145b6108a05760405162461bcd60e51b8152602060048201526013602482015272125b9d985b1a5908185c9c985e481a5b9c1d5d606a1b60448201526064015b60405180910390fd5b60006108de8787808060200260200160405190810160405280939291908181526020018383602002808284376000920191909152506121db92505050565b506042549091506000906001600160a01b031663d176d694604a848989610903612413565b6040518663ffffffff1660e01b815260040161092395949392919061556c565b60206040518083038186803b15801561093b57600080fd5b505afa15801561094f573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061097391906150a1565b9050610995604454670de0b6b3a764000061098e91906159bf565b8290612465565b6109a0906001615940565b98975050505050505050565b6060603680546109bb906159f6565b80601f01602080910402602001604051908101604052809291908181526020018280546109e7906159f6565b8015610a345780601f10610a0957610100808354040283529160200191610a34565b820191906000526020600020905b815481529060010190602001808311610a1757829003601f168201915b505050505090505b90565b6000610a4c338484612484565b5060015b92915050565b610a5e6125a9565b604554821115610aa05760405162461bcd60e51b815260206004820152600d60248201526c29bbb0b8103930ba329037b7b160991b6044820152606401610897565b604554811115610ae85760405162461bcd60e51b81526020600482015260136024820152722932b232b6b83a34b7b7103930ba329037b7b160691b6044820152606401610897565b6044829055604681905560408051838152602081018390527f64f84976d9c917a44796104a59950fdbd9b3c16a5dd348b546d738301f6bd06891015b60405180910390a15050565b6000808211610b515760405162461bcd60e51b8152600401610897906157ba565b6000610b5c84612613565b506042549091506001600160a01b0316637910213b604a8386610b7d612413565b6040518563ffffffff1660e01b8152600401610b9c94939291906155da565b60206040518083038186803b158015610bb457600080fd5b505afa158015610bc8573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610bec91906150a1565b949350505050565b6043546001600160a01b0316610c3f5760405162461bcd60e51b815260206004820152601060248201526f185b1c9958591e481d5c19dc9859195960821b6044820152606401610897565b604380546001600160a01b0319808216909255604d805460ff19166001179055604280546001600160a01b038681169190941617905560405163befb4bc960e01b815291166004820181905260496024830152604a6044830152604b60648301529073__$4ff61640dcfbdf6af5752b96f9de1a9efe$__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__$1a38b0db2bd175b310a9a3f8697d44eb75$__63bd5b0ac6604e8484611478612eff565b6040516001600160e01b031960e087901b168152600481019490945260248401929092526044830152606482810191909152608482015260a4015b60006040518083038186803b1580156114cb57600080fd5b505af41580156114df573d6000803e3d6000fd5b505050505050565b604a81815481106114f757600080fd5b6000918252602090912001546001600160801b038082169250600160801b9091041682565b6115246125a9565b60405163dbde178160e01b815273__$1a38b0db2bd175b310a9a3f8697d44eb75$__9063dbde17819061156590604990604b908890889088906004016156b4565b60006040518083038186803b15801561157d57600080fd5b505af4158015611591573d6000803e3d6000fd5b50505050505050565b6001600160a01b0381166000908152603360205260409020545b919050565b6000826001600160a01b0316846001600160a01b0316141561160c5760405162461bcd60e51b815260206004820152600c60248201526b24b73b30b634b2103830b4b960a11b6044820152606401610897565b600082116116545760405162461bcd60e51b8152602060048201526015602482015274496e76616c69642073776170207175616e7469747960581b6044820152606401610897565b6000604a805480602002602001604051908101604052809291908181526020016000905b828210156116c157600084815260209081902060408051808201909152908401546001600160801b038082168352600160801b9091041681830152825260019092019101611678565b50505050905060006116d286612613565b50905060006116e086612613565b506042546044549192506001600160a01b031690630e3c01d3908590859085908a9061170a612413565b6040518763ffffffff1660e01b815260040161172b9695949392919061552a565b604080518083038186803b15801561174257600080fd5b505afa158015611756573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061177a91906151dd565b50979650505050505050565b60008082116117a75760405162461bcd60e51b8152600401610897906157ba565b60006117b284612613565b50905060006117cc6044548561303c90919063ffffffff16565b6042549091506001600160a01b03166350494dc0604a846117ed85896159bf565b6117f5612413565b6040518563ffffffff1660e01b815260040161181494939291906155da565b60206040518083038186803b15801561182c57600080fd5b505afa158015611840573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061186491906150a1565b95945050505050565b60008061187861299d565b611880613051565b604154600160a01b900460ff166118a95760405162461bcd60e51b8152600401610897906157da565b6041805460ff60a01b1916905560425460609073__$1a38b0db2bd175b310a9a3f8697d44eb75$__90635bf4fec290604990604a906001600160a01b03166118ef612413565b6040518563ffffffff1660e01b815260040161190e9493929190615644565b60006040518083038186803b15801561192657600080fd5b505af415801561193a573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052611962919081019061510a565b9093509050826119ad5760405162461bcd60e51b81526020600482015260166024820152754d75737420636f6c6c65637420736f6d657468696e6760501b6044820152606401610897565b6119b733846129fc565b307f7d3ff197e9071095bd36b627028ef523ecf46fcbf17cbde745a4b65aec88b6bc33856000604051908082528060200260200182016040528015611a06578160200160208202803683370190505b5085604051611a18949392919061542b565b60405180910390a26035546041805460ff60a01b1916600160a01b1790559293915050565b611a456125a9565b6040516366bcdfe160e01b8152604d600482015260496024820152604b60448201526001600160a01b0383166064820152811515608482015273__$1a38b0db2bd175b310a9a3f8697d44eb75$__906366bcdfe19060a4016114b3565b6060603780546109bb906159f6565b611ab96125a9565b604051637269806d60e01b8152604d600482015260496024820152604b60448201526001600160a01b038216606482015273__$1a38b0db2bd175b310a9a3f8697d44eb75$__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__$1a38b0db2bd175b310a9a3f8697d44eb75$__90638e1e771d906084016114b3565b611f65614c30565b611f6d612413565b905090565b611f7a6125a9565b73__$1a38b0db2bd175b310a9a3f8697d44eb75$__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__$1a38b0db2bd175b310a9a3f8697d44eb75$__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__$1a38b0db2bd175b310a9a3f8697d44eb75$__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__$1a38b0db2bd175b310a9a3f8697d44eb75$__6322a7c742826049858154811061397d57634e487b7160e01b600052603260045260246000fd5b90600052602060002090600202018886815181106139ab57634e487b7160e01b600052603260045260246000fd5b60200260200101518f8c602001516040518663ffffffff1660e01b81526004016139d99594939291906158d0565b60006040518083038186803b1580156139f157600080fd5b505af4158015613a05573d6000803e3d6000fd5b50505050613a1281614b8c565b858381518110613a3257634e487b7160e01b600052603260045260246000fd5b602002602001015160200151613a489190615997565b604a8381548110613a6957634e487b7160e01b600052603260045260246000fd5b600091825260209091200180546001600160801b03928316600160801b0292169190911790555080613a9a81615a31565b915050613787565b50336001600160a01b03167fdf5bf345d5d6eedd0e8667d799d60af65d7127e3b0417e04bef4d954d2a4750e8a8e848c8c60405161359d959493929190615464565b60006001600160a01b038216613b0c5760405162461bcd60e51b81526004016108979061578f565b83518015801590613b1d5750855181145b613b605760405162461bcd60e51b8152602060048201526014602482015273092dce0eae840c2e4e4c2f240dad2e6dac2e8c6d60631b6044820152606401610897565b600080613b6c886121db565b915091506000604a805480602002602001604051908101604052809291908181526020016000905b82821015613bdd57600084815260209081902060408051808201909152908401546001600160801b038082168352600160801b9091041681830152825260019092019101613b94565b5050505090506000613bed614b18565b90506000856001600160401b03811115613c1757634e487b7160e01b600052604160045260246000fd5b604051908082528060200260200182016040528015613c40578160200160208202803683370190505b50905060005b86811015613e4a5760008b8281518110613c7057634e487b7160e01b600052603260045260246000fd5b602002602001015190506000811115613e37576000878381518110613ca557634e487b7160e01b600052603260045260246000fd5b602002602001015190506000868260ff1681518110613cd457634e487b7160e01b600052603260045260246000fd5b602002602001015190506000888581518110613d0057634e487b7160e01b600052603260045260246000fd5b60200260200101519050600073__$1a38b0db2bd175b310a9a3f8697d44eb75$__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__$1a38b0db2bd175b310a9a3f8697d44eb75$__638b8f35c186898960ff168151811061416857634e487b7160e01b600052603260045260246000fd5b6020026020010151600001518e86602001516040518563ffffffff1660e01b81526004016141999493929190615841565b60206040518083038186803b1580156141b157600080fd5b505af41580156141c5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906141e991906150a1565b90506141f481614b8c565b878760ff168151811061421757634e487b7160e01b600052603260045260246000fd5b60200260200101516020015161422d9190615915565b604a8760ff168154811061425157634e487b7160e01b600052603260045260246000fd5b6000918252602082200180546001600160801b03938416600160801b029316929092179091556042546044546001600160a01b0390911690630e3c01d3908a908a908990879061429f612413565b6040518763ffffffff1660e01b81526004016142c09695949392919061552a565b604080518083038186803b1580156142d757600080fd5b505afa1580156142eb573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061430f91906151dd565b90995090508a8910156143645760405162461bcd60e51b815260206004820152601860248201527f4f757470757420717479203c206d696e696d756d2071747900000000000000006044820152606401610897565b600089116143ab5760405162461bcd60e51b81526020600482015260146024820152735a65726f206f7574707574207175616e7469747960601b6044820152606401610897565b73__$1a38b0db2bd175b310a9a3f8697d44eb75$__6322a7c7428a868b8960ff16815181106143ea57634e487b7160e01b600052603260045260246000fd5b60200260200101518e88602001516040518663ffffffff1660e01b8152600401614418959493929190615881565b60006040518083038186803b15801561443057600080fd5b505af4158015614444573d6000803e3d6000fd5b5050505061445189614b8c565b888660ff168151811061447457634e487b7160e01b600052603260045260246000fd5b60200260200101516020015161448a9190615997565b604a8660ff16815481106144ae57634e487b7160e01b600052603260045260246000fd5b600091825260209091200180546001600160801b03928316600160801b02921691909117905560408301516144e4908290615940565b60485585518451604080516001600160a01b039384168152918316602083015281018b905260608101839052908b16608082015233907f1eeaa4acf3c225a4033105c2647625dbb298dec93b14e16253c4231e26c02b1d9060a00160405180910390a2505050505050505095945050505050565b60006001600160a01b0382166145805760405162461bcd60e51b81526004016108979061578f565b600084116145a05760405162461bcd60e51b8152600401610897906157ba565b6000604a805480602002602001604051908101604052809291908181526020016000905b8282101561460d57600084815260209081902060408051808201909152908401546001600160801b038082168352600160801b90910416818301528252600190920191016145c4565b50505050905060008061461f88612613565b91509150600061462d614b18565b9050600073__$1a38b0db2bd175b310a9a3f8697d44eb75$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";

export interface MusdV3LibraryAddresses {
  ["__$4ff61640dcfbdf6af5752b96f9de1a9efe$__"]: string;
  ["__$1a38b0db2bd175b310a9a3f8697d44eb75$__"]: string;
}
